"use client";

// import { Caveat } from "next/font/google";
import { Jersey_25 } from "next/font/google";
import { useState } from "react";
import { TypeAnimation } from "react-type-animation";

import { Panel, PanelHeader, PanelTitle } from "./panel";

// const fontFamily = Caveat({
//   weight: "700",
//   subsets: ["latin"],
// });

const fontFamily = Jersey_25({
  weight: "400",
  subsets: ["latin"],
});

export function CallBooking() {
  const [_typingStatus, setTypingStatus] = useState("Initializing");

  return (
    <Panel id="call-booking">
      <PanelHeader className="flex flex-col items-center gap-2 p-4">
        <PanelTitle>
          <TypeAnimation
            sequence={[
              1000,
              () => {
                setTypingStatus("Typing...");
              },
              "Ready to build something amazing?",
              2000,
              () => {
                setTypingStatus("Deleting...");
              },
              "",
              () => {
                setTypingStatus("Done Deleting");
              },
              1000,
              () => {
                setTypingStatus("Typing...");
              },
              "Expert developer at your service.",
              2000,
              () => {
                setTypingStatus("Deleting...");
              },
              "",
              () => {
                setTypingStatus("Done Deleting");
              },
              1000,
              () => {
                setTypingStatus("Typing...");
              },
              "Let's discuss your project needs!",
              2000,
              () => {
                setTypingStatus("Deleting...");
              },
              "",
              () => {
                setTypingStatus("Done Deleting");
              },
            ]}
            repeat={Infinity}
            className={`${fontFamily.className} text-2xl`}
          />
        </PanelTitle>
        <button
          className="mt-2 animate-pulse cursor-pointer rounded-full bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 px-8 py-3 font-semibold text-white shadow-lg [box-shadow:0_0_20px_rgba(79,70,229,0.6)] transition-all duration-300 [animation-duration:3s] hover:scale-105 hover:animate-none hover:from-blue-500 hover:via-indigo-500 hover:to-purple-500 focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:outline-none dark:focus:ring-offset-black"
          onClick={() => window.open("https://cal.com/tarekhammami", "_blank")}
        >
          Book a free call
        </button>
      </PanelHeader>
    </Panel>
  );
}
